import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subject } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  isLoading = new Subject<boolean>();
  regexDigits: RegExp = new RegExp(/^\d+$/g);
  regexAlphaNumeric: RegExp = new RegExp(/^[0-9a-zA-Z]+$/);
  specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  private brandSelectionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  brandSelectedEvent = this.brandSelectionSubject.asObservable();

  constructor(private snackBar: MatSnackBar, private spinnerService: NgxSpinnerService, private titleService: Title) { }

  showLoader() {
    this.isLoading.next(true);
  }

  hideLoader() {
    this.isLoading.next(false);
  }

  showSpinner() {
    this.spinnerService.show();
  }

  hideSpinner() {
    this.spinnerService.hide();
  }

  setPageTitle(title: string) {
    this.titleService.setTitle(`UDELinksAdmin App | ${title}`);
  }

  selectBrand(brand: string) {
    sessionStorage.setItem('brand', brand); //Check this before commit -- Sudhakar
    this.brandSelectionSubject.next(true);
  }

  closeSnackBar() {
    this.snackBar.dismiss();
  }

  openSnackBar(content: string, type: string, action?: string) {
    this.spinnerService.hide();

    this.snackBar.open(content, action, {
      duration: 7000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: type === 'error' ? 'error-snackbar' : type === 'warning' ? 'warning-snackbar' : 'info-snackbar',
      data: { message: content }
    });
  }

  downloadFile(response: HttpResponse<Blob>) {
    let blob: Blob = response.body as Blob;
    const fileName = response.headers.get('Content-Disposition')?.split('filename=')[1].replace(/["']/g, '').trim();
    let a = document.createElement('a');
    a.download = fileName ? fileName : 'undefined';
    a.href = window.URL.createObjectURL(blob);
    a.click();
  }

  restrictToNumbers(event: any) {
    this.restrictInput(event, this.regexDigits);
  }

  restrictToAlphaNumeric(event: any) {
    this.restrictInput(event, this.regexAlphaNumeric);
  }

  restrictInput(event: any, regex?: RegExp) {
    let value = event.target?.value;
    if (this.specialKeys.indexOf(event.key) !== -1 ||
      (event.keyCode == 67 && event.ctrlKey === true) ||
      (event.keyCode == 88 && event.ctrlKey === true) ||
      (event.keyCode == 86 && event.ctrlKey === true) ||
      event.keyCode == 13) {
      return;
    }

    let current: string = value;
    const position = event.target?.selectionStart;
    const next: string = [current?.slice(0, position), event.key, current?.slice(position)].join('');

    regex = regex ? regex : this.regexAlphaNumeric;

    if (next && !String(next).match(regex)) {
      event.preventDefault();
    }
  }

  getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts?.length === 2) {
      return parts.pop()?.split(';').shift();
    }
    return null;
  }
}